<script setup>
const props = defineProps({
  round: { type: Object, default: null }
})
</script>

<template>
  <template v-if="round">
    <template v-if="round.name">
      {{ round.name }}
      <small class="text-medium-emphasis">#{{ round.round_number }}</small>
    </template>
    <template v-else>
      {{ $t('label.round_n', { n: round.round_number }) }}
    </template>
  </template>
</template>
